import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const MainColumn = ({ children }) => {
    return (_jsx(Box, { marginTop: {
            "breakpoint.lg": "0",
        }, gridColumn: {
            "breakpoint.base": "col-start / span 4",
            "breakpoint.sm": "col-start / span 8",
            "breakpoint.lg": "col-start / span 8",
            "breakpoint.xl": "col-start 1 / span 8",
            "breakpoint.xxl": "col-start 2 / span 7",
            "breakpoint.xxxl": "col-start 2 / span 7",
        }, unsafe_className: "MainColumn", backgroundColor: "color.background.constant.white", borderRadius: {
            "breakpoint.base": "radius.16",
            "breakpoint.lg": "radius.none",
        }, paddingTop: {
            "breakpoint.lg": "spacing.none",
        }, unsafe_style: { zIndex: 10 }, children: children }));
};
